import React from 'react';
import { useSelector } from 'react-redux';

import { MapBanner } from '../../components/MapBanner';
import { selectOffersCount, selectQueryString } from '../../selectors/results';
import { trackMapViewButtonClicked } from './tracking';

export function MapBannerContainer() {
  const queryString = useSelector(selectQueryString);
  const offerCount = useSelector(selectOffersCount);

  const url = React.useMemo(() => ['/map/', queryString].filter(Boolean).join('?'), [queryString]);

  if (offerCount === 0) {
    return null;
  }

  return <MapBanner url={url} onClick={trackMapViewButtonClicked} />;
}
